module.exports = {
  CREATED: 'created', //                         # - F2M status to start
  PENDING: 'pending', //                         1 - En attente
  ACTIVATED: 'activated', //                     2 - Actif
  SUSPENDED: 'suspended', //                     3 - Suspendu
  TERMINATED: 'terminated', //                   4 - Résilié
  CLOSED: 'closed', //                           5 - Clos
  CANCELLING: 'cancelling', //                   # - F2M status to cancel
  CANCELLED: 'cancelled', //                     6 - Annulé
  TERMINATED_FOR_LOSS: 'terminatedForLoss', //   7 - Résilié pour Perte
  EXPIRED: 'expired', //                         8 - Échu
  FAILED: 'failed', //                            # - F2M status for failures
};
